<template>
  <div class="receivedialog" :style="{ display: receive ? 'block' : 'none' }">
    <!-- 签到弹框 -->
    <div class="dialog">
      <div class="close">
        <i @click="close" class="iconfont icon-guanbi-1"></i>
      </div>
      <div class="dialogmain">
        <div class="header">
          <b v-if="addtitle !== ''">{{ $t("300167") }}</b>
          <b v-else>{{ reward ? $t(gifttitle) : $t(title) }}</b>
          <p v-if="addtitle === '' && content">
            <b>{{ $t(content) }}</b>
          </p>
        </div>
        <div class="main">
          <!--连续签到可获得以下奖励-->
          <p>{{ $t("300172") }}</p>
          <div id="stuff" class="stuff">
            <dl
              :class="{ active: item.isUsed }"
              v-for="(item, index) in getconfig"
              :key="index"
            >
              <dt>
                <img
                  :src="
                    require('../assets/images/' +
                      gift[item.rewardType - 1].nosigin +
                      '.png')
                  "
                  alt=""
                />
                <p>{{ $t(gift[item.rewardType - 1].gifttitle) }}</p>
              </dt>
              <dd v-if="rewardConfigList.length > 0">
                <span :class="{ active: item.isUsed }">{{
                  !item.isUsed
                    ? $t("300174", {
                        num: rewardConfigList[index].seriesNum
                      })
                    : $t("300173")
                }}</span>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <div class="receivefoot">
        <span @click="close">{{ $t("300141") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { usermsg } from "../api/resource";
import { signConfigApi } from "../api/resource";
export default {
  props: {
    title: {
      type: String,
      default: "300179"
    },
    gifttitle: {
      type: String,
      default: "300178"
    },
    addtitle: {
      type: String,
      default: ""
    },
    receive: {
      type: Boolean,
      default: false
    },
    closegift: {
      type: Function,
      default: () => {}
    },
    getconfig: {
      type: Array
    },
    isget: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["token"])
  },
  watch: {
    getconfig(newval, old) {
      this.reward = newval.some(item => {
        if (item.isThisAward) {
          this.content = this.getcontent(item.rewardType);
        }
        return item.isThisAward;
      });
    }
  },
  data() {
    return {
      gift: [
        {
          day: 5,
          gifttitle: "300175", // 抵扣券
          nosigin: "coupon_light@2x"
        },
        {
          day: 3,
          gifttitle: "300176", // VIP等级
          nosigin: "vip_select@2x"
        },
        {
          day: 7,
          gifttitle: "300177", // 参与抽奖
          nosigin: "box@2x"
        }
      ],

      userMsg: {},
      reward: [],
      signconfig: {},
      rewardConfigList: [],
      content: ""
    };
  },
  created() {
    if (this.token) {
      signConfigApi().then(res => {
        this.rewardConfigList = res.data.rewardConfigList;
      });
      usermsg().then(res => {
        this.userMsg = res.data;
      });
    }
  },
  methods: {
    close() {
      this.closegift(false);
    },
    getcontent(type) {
      switch (type) {
        case 1:
          return "300157";
        case 2:
          return "300158";
        case 3:
          return "300159";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../style/mixin";
@import "../assets/css/variableName";
.receivedialog {
  height: auto;
}
.receivefoot {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: torem(24);

  span {
    display: inline-block;
    width: torem(175);
    height: torem(44);
    border-radius: torem(22);
    text-align: center;
    line-height: torem(44);
    color: #333333;
    background: #ffc728;
    font-size: torem(14);
  }
}

.close {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-content: center;
  font-size: torem(12);
  color: rgba(255, 255, 255, 0.4);
}

.dialog {
  // position: absolute;
  display: flex;
  flex-direction: column;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  width: torem(312);
  background: #27282E;
  border-radius: torem(16);
  padding: torem(24) torem(20);
}

#stuff {
  display: flex;
  justify-content: center;
  align-items: center;
  > dl {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    dt {
      height: torem(90);
      width: 100%;
      text-align: center;

      img {
        width: torem(64);
        height: torem(46);
        margin-top: torem(15);
      }

      p {
        width: 100%;
        padding: 0 torem(5);
        font-size: torem(14);
        color: rgba(255, 255, 255, 0.6);
        box-sizing: border-box;
        word-break: break-all;
        line-height: torem(14);
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }

    &:nth-child(2) {
      margin: 0 torem(7);
    }

    height: torem(114);
    border: 1px solid rgba(255, 255, 255, 0.05);
    width: torem(92);
    box-sizing: border-box;
    border-radius: torem(7);
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    align-items: center;

    dd {
      width: torem(92);
      height: torem(29);
      background: rgba(255, 255, 255, 0.05);
      text-align: center;
      line-height: torem(28);
      color: rgba(255, 255, 255, 0.50);
      font-weight: 600;
      font-size: torem(12);
      border: none;
      border-radius: 0 0 torem(5) torem(5);
    }

    &.active {
      border-color: #ffc728;

      dd {
        background: #ffc728;
      }
    }
  }
}

.header {
  width: 100%;
  padding: torem(24) 0;
  text-align: center;
  font-size: torem(16);
  color: #fff;

  p {
    font-size: torem(16);
    text-align: center;
    height: torem(30);
    line-height: torem(30);
  }
}

.main {
  > p {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: torem(24) !important;
    font-size: torem(14);
    color: rgba(255, 255, 255, 0.6);
    line-height: torem(14) !important;
  }
}

.dialogmain {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/compontents/Receivedialog.vue